module.exports = __webpack_public_path__ + "img/203.fdb72eea.jpg";